import {DeviceActionType} from '@/constants/deviceActionType';
import {POWER, WIFI_STATUS} from '@/constants/pcConstAppData';

/**
 * store current device modules state
 * 1. Wifi Module
 * 2. Device Power Status
 */
export const initialState = {
  WifiStatus: WIFI_STATUS.OFF,
  Power: POWER.ON,
  Timezone: '',
  UserSelectedTimezone: '',
  UserSelectedDate: '',
  UserSelectedTime: '',
  OriginTimezone: '',
  TimezoneChanged: false,
  DateTimeChanged: false,
  isEditTimezoneSetting: false,
  timezoneSetting: null,
  timezoneSettingManual: null,
  timezoneSettingManualOriginal: null,
};

/**
 * @param {initialState} state
 * @param {Object} action
 * @param {DeviceActionType} action.type
 * @param {Object} action.value
 */
export const deviceStore = (state = initialState, action = {}) => {
  const {type, value} = action;
  switch (type) {
    case DeviceActionType.WIFI_STATUS:
      return {...state, WifiStatus: value};

    case DeviceActionType.POWER:
      return {...state, Power: value};

    case DeviceActionType.TIMEZONE:
      return {...state, Timezone: value};

    case DeviceActionType.USER_SELECTED_TIMEZONE:
      return {...state, UserSelectedTimezone: value};

    case DeviceActionType.USER_SELECTED_DATE:
      return {...state, UserSelectedDate: value};

    case DeviceActionType.USER_SELECTED_TIME:
      return {...state, UserSelectedTime: value};

    case DeviceActionType.ORIGIN_TIMEZONE:
      return {...state, OriginTimezone: value};

    case DeviceActionType.TIMEZONE_CHANGED:
      return {...state, TimezoneChanged: value};

    case DeviceActionType.DATETIME_CHANGED:
      return {...state, DateTimeChanged: value};

    case DeviceActionType.EDIT_TIMEZONE_SETTING:
      return {...state, isEditTimezoneSetting: value};

    case DeviceActionType.SET_TIMEZONE_OPTION:
      return {...state, timezoneSetting: value};

    case DeviceActionType.SET_TIMEZONE_OPTION_MANUAL:
      return {...state, timezoneSettingManual: value};

    case DeviceActionType.SET_TIMEZONE_OPTION_MANUAL_ORIGINAL:
      return {...state, timezoneSettingManualOriginal: value};

    default:
      return state;
  }
};
